const EVENT = "marsilya:support";

export function openSupport(detail = {}) {
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { action: "open", ...detail } }));
}

export function subscribeSupport(handler) {
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(EVENT, listener);
  return () => window.removeEventListener(EVENT, listener);
}

export const TICKET_STATUS = {
  open: "Açık",
  waiting: "Beklemede",
  in_progress: "İşlemde",
  approved: "Onaylandı",
  resolved: "Çözüldü",
  closed: "Kapatıldı",
};

export const ticketStatusLabel = (status) => TICKET_STATUS[status] || status || "—";

export const threadKindLabel = (kind) => (kind === "ticket" ? "Talep" : "Canlı");
